import { Box, IconButton, InputAdornment, TextField } from "@mui/material"
import { Close, Search } from "@mui/icons-material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { useState } from "react"
import { makeStyles } from "tss-react/mui"
import type * as React from "react"

const useStyles = makeStyles()(() => ({
    searchContainer: {
        position: "relative",
        display: "flex",
        alignItems: "center",
    },
    searchInput: {
        width: "0px",
        opacity: 0,
        transform: "scaleX(0)",
        transition: "width 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
    },
    searchInputVisible: {
        width: "10rem",
        opacity: 1,
        transform: "scaleX(1)",
    },
}))

export function MeetingSearch({
    searchQuery,
    setSearchQuery,
}: {
    searchQuery: string
    setSearchQuery: (query: string) => void
}) {
    const { classes } = useStyles()
    const [showSearch, setShowSearch] = useState(false)

    return (
        <Box className={classes.searchContainer}>
            {!showSearch && (
                <IconButton onClick={() => setShowSearch(true)}>
                    <Search sx={{ color: "#94A3B8" }} />
                </IconButton>
            )}
            <LocalizedStrict attrs={{ placeholder: true }} id="service-center-reports-dashboard-search-label">
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Search"
                    className={`${classes.searchInput} ${showSearch ? classes.searchInputVisible : ""}`}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search sx={{ color: "#94A3B8", cursor: "pointer" }} />
                            </InputAdornment>
                        ),
                        sx: {
                            borderRadius: ".75rem",
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#CBD5E1",
                            },
                        },
                        endAdornment: (
                            <IconButton
                                size="small"
                                onClick={() => {
                                    setShowSearch(false)
                                    setSearchQuery("")
                                }}
                            >
                                <Close fontSize="small" sx={{ color: "#94A3B8", cursor: "pointer" }} />
                            </IconButton>
                        ),
                    }}
                />
            </LocalizedStrict>
        </Box>
    )
}
